import type { CtlBranch } from "@/api/useGetCtlMapApi";

const escapeHtml = (value: string) =>
  value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

export const buildBranchInfoWindowContent = (branch: CtlBranch) => {
  const name = escapeHtml(branch.name);
  const address = escapeHtml(branch.address);
  const linkUrl = branch.linkUrl?.trim();
  const safeLink = linkUrl ? escapeHtml(linkUrl) : "";
  const imageUrl = branch.imageUrl?.trim();
  const safeImageUrl = imageUrl ? escapeHtml(imageUrl) : "";

  const link = safeLink
    ? `<a href="${safeLink}" target="_blank" rel="noopener noreferrer" style="display:inline-block;margin-top:6px;font-size:12px;color:#1a73e8;text-decoration:none;">바로가기 →</a>`
    : "";

  const preview = safeImageUrl
    ? `<div style="width:196px;height:110px;margin-bottom:8px;border-radius:8px;overflow:hidden;background:#f3f4f6;"><img src="${safeImageUrl}" alt="${name}" style="width:100%;height:100%;object-fit:cover;display:block;" onerror="this.style.display='none';" /></div>`
    : "";

  return `<div style="padding:10px 12px;width:220px;white-space:normal;word-break:keep-all;overflow-wrap:anywhere;line-height:1.4;">${preview}<p style="font-size:13px;font-weight:700;margin:0 0 4px;">${name}</p><p style="font-size:12px;color:#777;margin:0;">${address}</p>${link}</div>`;
};
